import { Button, Group, Modal, TextInput } from "@mantine/core";
import React from "react";

interface AddPillModalProps {
  opened: boolean;
  setOpened: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddPill: (newPill: string) => void;
  newPillLabel: string;
  setNewPillLabel: React.Dispatch<React.SetStateAction<string>>;
  handleSaveEdit: () => void;
  editMode: boolean;
  t: (key: string) => string;
}

const AddPillModal: React.FC<AddPillModalProps> = ({
  opened,
  setOpened,
  handleAddPill,
  newPillLabel,
  setNewPillLabel,
  handleSaveEdit,
  editMode,
  t,
}) => {
  const handleSubmit = () => {
    if (editMode) {
      handleSaveEdit();
    } else {
      handleAddPill(newPillLabel);
    }
  };

  const closeModal = () => {
    setOpened(false);
    setNewPillLabel("");
  };

  return (
    <Modal
      opened={opened}
      onClose={() => setOpened(false)}
      title={editMode ? t("common.edit") : t("common.create")}
    >
      <TextInput
        label={t("scheme.redactor.panelOptions.setSector.selectHallPart.label")}
        value={newPillLabel}
        onChange={(e) => setNewPillLabel(e.currentTarget.value)}
        placeholder={t(
          "scheme.redactor.panelOptions.setSector.selectHallPart.label"
        )}
      />
      <Group mt="md">
        <Button variant="outline" onClick={closeModal}>
          {t("common.cancel")}
        </Button>
        <Button onClick={handleSubmit}>
          {editMode ? t("common.save") : t("common.create")}
        </Button>
      </Group>
    </Modal>
  );
};

export default React.memo(AddPillModal);
